<template>
  <div class="mgl-map-wrapper">
    <div ref="container"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl"

export default {
  name: 'MapBox',
  props: {
    accessToken: {
      type: String,
      required: true
    },
    mapStyle: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      map: null,
      mapbox: null
    }
  },
  mounted() {
    this.mapbox = mapboxgl
    this.mapbox.accessToken = this.accessToken
    this.map = new this.mapbox.Map(
      Object.assign(this.options, {
        container: this.$refs.container,
        style: this.mapStyle
      })
    )
    this.map.on('load', () => { 
      this.$emit("load", { map: this.map })
    })
  },
  beforeDestroy() {
    this.$nextTick(() => {
      if (this.map) this.map.remove();
    })
  }
}
</script>

<style>
.mgl-map-wrapper {
  height: 100%;
  position: relative;
  width: 100%;
}
.mgl-map-wrapper .mapboxgl-map {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>